import { Factory } from './Factory'
import { FormColumnFactory} from './FormColumnFactory'
export class FormRowFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  create() {
    return {
      id: this.id('form-row'),
      columns: [(new FormColumnFactory).create()]
    }
  }
}